/* Created By CoolGuy on 2017/11/13
*/
import {observable} from 'mobx';
export default class UserStore{
    @observable userData = {};
    constructor(rootStore){
        this.rootStore = rootStore;
    }
}


// WEBPACK FOOTER //
// ./src/store/UserStore.js